import React from 'react';
import PropTypes from 'prop-types';
import { pushGtmData } from '../util/gtm'
 
class CallToActionImageBlock extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        const style = this.props.image && this.props.image !== "null"
            ? {'backgroundImage': 'url(' + this.props.image + ')'} 
            : {};

        return (
            <div className={"call-to-action call-to-action--image call-to-action--bg-" + this.props.color}>
                <div className="call-to-action__body">
                    <p className="call-to-action__text">{this.props.text}</p>
                    <a href={this.props.linkUrl} className="call-to-action__link" onClick={() => { pushGtmData(this.props.linkGTMCategory, this.props.linkGTMAction, this.props.linkGTMLabel); }}>
                        {this.props.linkText}
                    </a>
                </div>
                <div className="call-to-action__image" style={style} />
            </div>
        );
    }
}

CallToActionImageBlock.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    image: PropTypes.string,
    linkUrl: PropTypes.string,
    linkText: PropTypes.string,
    linkGTMCategory: PropTypes.string,
    linkGTMAction: PropTypes.string,
    linkGTMLabel: PropTypes.string
};

export default CallToActionImageBlock;